// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X5e5","right":"styles_right__2J-lp"};